module.exports = __webpack_public_path__ + "img/9.2981baa1.png";